import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d273ed7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-subtitle text-muted" }
const _hoisted_5 = { class: "card-body my-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmergencyDetailCompoent = _resolveComponent("EmergencyDetailCompoent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(["fas me-2", _ctx.icon])
        }, null, 2),
        _createTextVNode("ข้อมูลรายละเอียด")
      ]),
      _createElementVNode("h6", _hoisted_4, "ข้อมูลรายละเอียด" + _toDisplayString(_ctx.subtitle) + " ของ" + _toDisplayString(_ctx.provinceName), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_EmergencyDetailCompoent, {
        "emergency-id": _ctx.emergency?.id
      }, null, 8, ["emergency-id"])
    ])
  ]))
}